// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import 'es6-promise/auto'
import store from './store'
import Vuetable from 'vuetable-2'
import VueI18n from 'vue-i18n'
import moment from 'vue-moment'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$moment = moment

Vue.use(Vuetable)
Vue.use(VueI18n)

let PulseLoader = require('vue-spinner/src/PulseLoader')

require('../src/assets/services/axios-interceptor')

let validator = require('../src/assets/services/validator')
Vue.prototype.$validator = validator

const i18n = new VueI18n({
  locale: store.state.loading.language, // set locale
  fallbackLocale: 'hu',
  silentTranslationWarn: true,
  messages: {
    en: store.state.loading.languages.en,
    hu: store.state.loading.languages.hu
  } // set locale messages
})

Vue.prototype.$translate = i18n

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App, PulseLoader },
  template: '<App/>',
  beforeMount () {

  },
  mounted () {
  }
})



// WEBPACK FOOTER //
// ./src/main.js